<p *ngIf="loading && !progress" class="br-text-muted" role="status">Loading campaign results…</p>
<div *ngIf="progress" class="campaign-chart-grid">
  <ng-container *ngIf="view === 'goals'">
    <section class="br-card br-p-3">
      <div class="br-flex br-justify-between br-items-center br-gap-2 br-mb-2">
        <h3 class="br-section-title br-m-0" title="Campaign Leads that reached a won stage after joining.">New customers</h3>
        <strong>{{ progress.won }}<span *ngIf="targetCustomers != null" class="br-text-muted"> / {{ targetCustomers }}</span></strong>
      </div>
      <div *ngIf="hasWeeks; else noWeeks" class="campaign-chart-frame">
        <canvas baseChart type="line" [data]="customers" [options]="lineOptions" role="img"
                [attr.aria-label]="'New customers won so far: ' + progress.won"></canvas>
      </div>
    </section>
    <section class="br-card br-p-3">
      <div class="br-flex br-justify-between br-items-center br-gap-2 br-mb-2">
        <h3 class="br-section-title br-m-0" title="Expected annual revenue of the won campaign Leads.">Revenue</h3>
        <strong>{{ progress.wonRevenue | number:'1.0-0' }}<span *ngIf="targetRevenue != null" class="br-text-muted"> / {{ targetRevenue | number:'1.0-0' }}</span></strong>
      </div>
      <div *ngIf="hasWeeks; else noWeeks" class="campaign-chart-frame">
        <canvas baseChart type="line" [data]="revenue" [options]="lineOptions" role="img"
                [attr.aria-label]="'Expected annual revenue of won Leads: ' + progress.wonRevenue"></canvas>
      </div>
    </section>
  </ng-container>
  <ng-container *ngIf="view === 'results'">
    <section class="br-card br-p-3">
      <h3 class="br-section-title br-mb-2" title="Contacted and quoted count activity and quotes after a Lead joined.">Funnel</h3>
      <div class="campaign-chart-frame">
        <canvas baseChart type="bar" [data]="funnel" [options]="funnelOptions" role="img" [attr.aria-label]="'Funnel. ' + funnelSummary"></canvas>
      </div>
    </section>
    <section class="br-card br-p-3">
      <h3 class="br-section-title br-mb-2" title="Calls, visits, emails and meetings logged on campaign Leads.">Weekly contact</h3>
      <div *ngIf="hasWeeks; else noWeeks" class="campaign-chart-frame">
        <canvas baseChart type="bar" [data]="activity" [options]="activityOptions" role="img" [attr.aria-label]="'Logged contact. ' + activitySummary"></canvas>
      </div>
    </section>
  </ng-container>
</div>
<ng-template #noWeeks><div class="campaign-chart-empty br-text-muted">Results appear once the campaign period starts.</div></ng-template>
